export {};

declare global {
    interface Window {
        dataLayer: any[];
    }
}

declare const owEssentials: {
    debug: boolean;
    defaultPayload: Record<string, unknown>;
};

class Tracking {
    defaultPayload: Record<string, unknown>;
    debug: boolean;

    constructor() {
        if (!window.dataLayer) {
            window.dataLayer = [];
        }

        this.defaultPayload = owEssentials.defaultPayload;
        this.debug = owEssentials.debug;

        this.push({ event: 'page_view' });
        this.registerClickEvents();
    }

    private push(payload: Record<string, unknown>): void {
        const data = { ...this.defaultPayload, ...payload };
        window.dataLayer.push(data);

        if (this.debug) {
            let message = '[OW Essentials] Pushed to dataLayer';
            if (data.event) {
                message += `: ${data.event}`;
            }

            console.log(message, data);
        }
    }

    private registerClickEvents(): void {
        document.addEventListener('click', (event) => {
            const target = event.target as HTMLElement;
            const gtmElement = target.closest('[data-gtm-event]');

            if (gtmElement) {
                const payload = (gtmElement as HTMLElement).dataset.gtmEvent;
                if (payload) {
                    this.push(JSON.parse(payload));
                }
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new Tracking();
});
